"use client";

import { usuarioKeys } from "@login";
import { type UsuarioResponse } from "@apiUser";
import {
  useQuery,
  type UseQueryOptions,
  type UseQueryResult,
} from "@tanstack/react-query";

/* =======================================================================
 * HOOK DE ACESSO (DADOS DO USUÁRIO)
 * ======================================================================= */

/**
 * Hook para buscar os dados de acesso do usuário (dados cadastrais, grupos, cadastros).
 * Use acesso.refetch() para buscar manualmente após autenticação.
 */
export function useAcessoMutation(
  login: string,
  options: Omit<
    UseQueryOptions<
      UsuarioResponse,
      Error,
      UsuarioResponse,
      ReturnType<typeof usuarioKeys.detail>
    >,
    "queryKey" | "queryFn"
  > = {}
): UseQueryResult<UsuarioResponse, Error> {
  const { enabled = true, staleTime = 300_000, ...restOpts } = options;

  return useQuery<
    UsuarioResponse,
    Error,
    UsuarioResponse,
    ReturnType<typeof usuarioKeys.detail>
  >({
    queryKey: usuarioKeys.detail(login),
    queryFn: async () => {
      const response = await fetch(`/api/usuario/${login}`);
      if (!response.ok) {
        const errorData = await response.json();
        console.log(
          errorData.error?.message || "Falha ao obter dados do usuário."
        );
      }
      const { data } = await response.json();
      if (!data.cadastros) {
        data.cadastros = { condicoesPagamento: [], centrosCusto: [] };
      }
      return data;
    },
    enabled: Boolean(login) && enabled,
    staleTime,
    ...restOpts,
  });
}
